module.exports = __webpack_public_path__ + "static/media/invite.5911f723.svg";